import React from "react";
import "./LearnDetails.css";
import LatestVideos from "./youtubeVideos/LatestVideos";
import LearnTable from "./learnTable/LearnTable";
import { useTranslation } from "../i18n";

function LearnDetails() {
    const { t } = useTranslation();

    return (
        <section className="learn-details-shell">
            <LatestVideos />
            <hr className="section-divider" />

            <section className="learn-roadmap-container">
                <div className="learn-roadmap-header">
                    <div className="learn-roadmap-copy">
                        <span className="learn-roadmap-kicker">{t("learn.roadmapKicker")}</span>
                        <h2>{t("learn.frameworksTitle")}</h2>
                        <p>{t("learn.frameworksText")}</p>
                    </div>
                    <div className="learn-roadmap-aside">
                        <strong>{t("learn.roadmapAsideTitle")}</strong>
                        <span>{t("learn.roadmapAsideText")}</span>
                    </div>
                </div>
                <LearnTable/>
            </section>
        </section>
    );
}

export default LearnDetails;
